import { ref, watchEffect } from 'vue'
import debounce from 'lodash/debounce'
import { useGridState } from '@/Components/DataGrid/Composables/grid-state'

export const useColumnStateManagement = ({ gridApi, name }) => {
  const { context } = useGridState()

  const columnStateStorageKey = `${name}_column_state`

  const restoreColumnState = () => {
    try {
      const savedState = JSON.parse(localStorage.getItem(columnStateStorageKey))
      if (savedState) {
        context.isCustomColumns = true
        gridApi.value.applyColumnState({
          state: savedState,
          applyOrder: true
        })
      }
    } catch {
      console.info('No saved state loaded.')
    }
  }

  const saveColumnState = debounce(
    (e) => {
      const savedState = gridApi.value.getColumnState()
      localStorage.setItem(columnStateStorageKey, JSON.stringify(savedState))
      context.isCustomColumns = true
    },
    150,
    { maxWait: 500 }
  )

  context.resetColumns = () => {
    gridApi.value.resetColumnState()
    localStorage.removeItem(columnStateStorageKey)
    context.isCustomColumns = false
  }

  watchEffect(() => {
    if (gridApi.value) {
      restoreColumnState()
      ;['columnVisible', 'columnMoved', 'columnChanged', 'columnResized'].forEach((eventName) => {
        gridApi.value.addEventListener(eventName, (e) => {
          if (e.source !== 'api' && e.source !== 'flex') {
            saveColumnState()
          }
        })
      })
    }
  })
}
